import { send } from '../../../src/network';

export const LikeDislike = {
  NoRating: null,
  Liked: true,
  Disliked: false,
} as const;

export type LikeDislikeRatings = (typeof LikeDislike)[keyof typeof LikeDislike];

type UserDefinedRating = Exclude<LikeDislikeRatings, undefined>;

interface Params {
  liked: UserDefinedRating;
  pairingId: number;
  orderId: number;
  feedback: string;
  rating?: 0 | 1 | 2 | 3 | 4 | 5;
}

export function setPairingRating(params: Params) {
  const { liked, pairingId, orderId, feedback, rating } = params;

  const payload: {
    liked: Params['liked'];
    pairing_id: Params['pairingId'];
    order_id: Params['orderId'];
    feedback: Params['feedback'];
    rating?: Params['rating'];
  } = {
    liked,
    pairing_id: pairingId,
    order_id: orderId,
    feedback,
  };

  if (rating !== undefined) {
    payload.rating = rating;
  }

  return send<boolean>({
    method: 'POST',
    path: '/api/set_pairing_rating/',
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }),
    body: payload,
  });
}
